import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    filterPlaceholder: translate({ id: 'traffic.trafficProfile.list.filterPlaceholder' }),
  }))

  return api
}
